import React, { useState, useEffect, useRef, useCallback } from 'react';
import Popover from '@mui/material/Popover';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { FormsList } from '../FormsList/forms-list';
import { Orders } from '../Orders/Orders';
import { Cart } from '../Cart/cart';
import { useStore } from 'Store/pages/forms/store';
import './index.scss';

const CartMemo = React.memo(Cart);

function Index() {
  const loadCart = useStore((state) => state.LOAD_FROM_COOKIE);
  const [anchorEl, setAnchorEl] = useState(null);
  const [cartActive, setCartActive] = useState(false);
  const cartRef = useRef(null);
  const open = Boolean(anchorEl);

  const cartClick = () => {
    if (anchorEl === null) {
      setAnchorEl(cartRef.current);
      setCartActive(true);
    } else {
      setAnchorEl(null);
      setCartActive(false);
    }
  };

  const cartClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  useEffect(() => {
    loadCart();
  }, []);

  return (
    <>
      <div className="row page-heading mt-5">
        <h3>Forms</h3>
      </div>
      <div className="row sub-navigation">
        <ul className="nav nav-tabs overlapping-tabs mb-3">
          <li className="nav-item">
            <a
              className="nav-link active"
              id="pills-forms-tab"
              data-toggle="pill"
              href="#pills-forms"
              role="tab"
              aria-controls="pills-forms"
              aria-selected="true"
            >
              Forms
            </a>
          </li>
          <li className="nav-item">
            <a
              className="nav-link"
              id="pills-orders-tab"
              data-toggle="pill"
              href="#pills-orders"
              role="tab"
              aria-controls="pills-orders"
              aria-selected="false"
            >
              Orders
            </a>
          </li>
        </ul>
        <div
          className={cartActive ? 'cart-popover-icon active' : 'cart-popover-icon'}
          ref={cartRef}
          onClick={cartClick}
        >
          <ShoppingCartIcon />
        </div>
        <Popover
          id="cart-popover"
          open={open}
          anchorEl={anchorEl}
          onClose={cartClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <CartMemo toggleCart={cartClick} />
        </Popover>
      </div>
      <div className="row content">
        <div className="tab-content col-12 col-lg-9 pl-0 pr-0 pr-lg-1" id="pills-tabContent">
          <div
            className="tab-pane fade show active"
            id="pills-forms"
            role="tabpanel"
            aria-labelledby="pills-forms-tab"
          >
            <FormsList />
          </div>
          <div
            className="tab-pane fade"
            id="pills-orders"
            role="tabpanel"
            aria-labelledby="pills-orders-tab"
          >
            <Orders />
          </div>
        </div>
        <div className="cart-wrapper col-lg-3">
          <CartMemo />
        </div>
      </div>
    </>
  );
}

export { Index };
